import { FeatureCollection, Point } from "@turf/helpers";
import { MapSearchResult } from "../models/map-search.models";

export type PoiSearchResultResponseBody = FeatureCollection<Point, SearchResultItem>;

interface SearchResultItem {
    osm_type: string;
    osm_id: number;
    osm_key: string;
    osm_value: string;
    type: string;
    postcode?: string;
    countrycode?: string;
    name: string;
    country: string;
    state?: string;
    county?: string;
    city?: string;
    extent?: number[];
    street?: string;
    housenumber?: string;
}

export function convertSearchResultResponseBodyToSearchResults(response?: PoiSearchResultResponseBody): MapSearchResult[] {
    const searchResults: MapSearchResult[] = [];

    response?.features.forEach(({ properties, geometry }) => {
        const [minY, maxY, minX, maxX] = properties?.extent ?? [];
        const { name, city, street, housenumber, postcode, county, state, country } = properties;
        const streetAndNumber = [street, housenumber].filter(Boolean).join(" ");

        searchResults.push({
            name: [name, city, streetAndNumber, postcode, county, state, country].filter(Boolean).join(", "),
            type: "PIN",
            latitude: Number(geometry.coordinates[1]),
            longitude: Number(geometry.coordinates[0]),
            boundingBox: { minX, minY, maxX, maxY },
        });
    });

    return searchResults;
}
